import { useState } from "react";
import LeadRemarksModal from "./LeadRemarksModal";
import { useSelector } from "react-redux";
import { useLanguage } from "@src/context/LanguageContext";
const LeadRemarksButton = (props: any) => {

    const { leadId, remark_source } = props;

    const [remarkHistory, setRemarkHistory] = useState(false);
    const [selectedRemarkLead, setSelectedRemarkLead] = useState(false);

    const insuranceState = useSelector((state: any) => state.insurance);
    const {translations} = useLanguage();

    /**
     * HAHNDLE REMARK POPUP
     * @param type 
     * @param leadId 
     */
    const handleRemarkTimeline = (type: boolean, leadId: any) => {
        setRemarkHistory(type);
        setSelectedRemarkLead(leadId);

    }

    return (
        <>
            <button type="button" className="btn-line" disabled={props.disabled} onClick={() => handleRemarkTimeline(true, leadId)}>{translations.Insurance?.['Remarks'] || translations.commonMsg?.loading} ({insuranceState?.leadDetail?.leadRemarkCount || 0})</button>

            {remarkHistory && <LeadRemarksModal remarkHistory={remarkHistory} selectedRemarkLead={selectedRemarkLead} handleRemarkTimeline={(action: boolean, leadId: any) => handleRemarkTimeline(action, leadId)} policyShareModal={props.policyShareModal} remark_source={remark_source} />}
        </>

    )
}


export default LeadRemarksButton;